import { Component, ElementRef, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CardFilteringBaseComponent } from '@shared/modules/filter-components/components/card-filtering-base/card-filtering-base.component';
import { FormControl } from '@angular/forms';
import { FilteringService } from '@shared/modules/filter-components/services/filtering.service';
import { BehaviorSubject } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { IdNameFilterOption } from '@shared/modules/filter-components/components/truefalse-filtering/classes/IdNameFilterOption';
import { AppStateService } from '@shared/services/app-state.service';

@UntilDestroy()
@Component({
  selector: 'app-truefalse-filtering',
  templateUrl: './truefalse-filtering.component.html',
  styleUrls: ['./truefalse-filtering.component.scss'],
})
export class TruefalseFilteringComponent extends CardFilteringBaseComponent implements OnInit {
  selectedItems = new FormControl();
  selected: BehaviorSubject<IdNameFilterOption[]> = new BehaviorSubject<IdNameFilterOption[]>([]);
  options: IdNameFilterOption[];

  constructor(
    readonly eRef: ElementRef<HTMLElement>,
    readonly filteringService: FilteringService,
    readonly translate: TranslateService,
    readonly appStateService: AppStateService
  ) {
    super(eRef, filteringService, translate);
  }

  ngOnInit() {
    this.options = this.appStateService.getYesNoOptionsPure();

    this.listenTrueFalseSelectorChange();

    this.listenFilterResetAction()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.deleteItem();
      });

    this.listenSavedFilterChange(this.filterKey)
      .pipe(untilDestroyed(this))
      .subscribe((items: unknown) => {
        this.setValueForControls(items as boolean);
      });

    this.selected.pipe(delay(200), untilDestroyed(this)).subscribe((values) => {
      this.isOpen = values?.length > 0;
    });

    return super.ngOnInit();
  }

  get selectedItem() {
    return this.selected.asObservable();
  }

  onCheckboxChanged(isChecked: boolean) {
    this.isChecked = isChecked;
    this.isOpen = false;
    this.filterValueChange.emit({
      [this.filterKey]: isChecked ? (this.selectedItems.value as IdNameFilterOption).id : undefined,
    });
  }

  private setValueForControls(valueOfControl: boolean | undefined): void {
    if (typeof valueOfControl !== 'undefined') {
      const sortedItems = this.sortSelectedFromExisting(valueOfControl);
      this.selectedItems.setValue(sortedItems[0]);
    } else {
      this.selectedItems.reset();
    }
  }

  private sortSelectedFromExisting(trueFalseValue: boolean): Object[] {
    return this.options.filter((value) => value.id === trueFalseValue);
  }

  private listenTrueFalseSelectorChange(): void {
    this.selectedItems.valueChanges
      .pipe(
        tap((value: IdNameFilterOption) => {
          this.selected.next(value ? [value] : null);
          this.isDisabled = !value;

          this.isChecked = value && value.id;

          if (value?.id === false) {
            this.isChecked = !this.isChecked;
          }

          this.filterValueChange.emit({ [this.filterKey]: value ? value.id : undefined });
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }

  deleteItem() {
    this.selectedItems.reset();
  }
}
